import AudioPlayer from "@/components/AudioPlayer";
import Block from "@/components/Block";
import BlockList from "@/components/BlockList";
import Blockquote from "@/components/Blockquote";
import BodyText from "@/components/BodyText";
import EmbeddedTweet from "@/components/EmbeddedTweet";
import FeedbackForm from "@/components/FeedbackForm";
import HorizontalRule from "@/components/HorizontalRule";
import LinkButton from "@/components/LinkButton";
import style from "@/components/ResourceBlocks.module.scss";
import SingleImage from "@/components/SingleImage";
import SubHeading from "@/components/SubHeading";
import VideoEmbed from "@/components/VideoEmbed";
import clsx from "clsx";
import React from "react";

const ResourceBlocks = ({ resource, blocks }) => {
  const Component = ({ block }) => {
    switch (block.typeHandle) {
      case "heading": {
        return <SubHeading heading={block.heading} />;
      }

      case "horizontalRule": {
        return <HorizontalRule />;
      }

      case "text": {
        return (
          <div className={clsx("w-full px-6 lg:px-16")}>
            <div className={clsx("mx-auto max-w-prose")}>
              <BodyText text={block.text} />
            </div>
          </div>
        );
      }

      case "embeddedTweet": {
        return <EmbeddedTweet tweetUrl={block.tweetUrl} />;
      }

      case "blockList": {
        return (
          <div className={clsx("w-full px-6 lg:px-16")}>
            <div className={clsx("mx-auto max-w-prose")}>
              <BlockList>
                {block.blocks.map((block, _i) => {
                  return (
                    <BlockList.Block
                      key={block.id}
                      number={_i + 1}
                      heading={block.heading}
                      text={block.text}
                      target={block.target}
                    />
                  );
                })}
              </BlockList>
            </div>{" "}
          </div>
        );
      }

      case "linkButton": {
        return <LinkButton label={block.label} target={block.target} />;
      }

      case "image": {
        const image = block.image?.[0];

        return (
          <div className={clsx("w-full px-6 lg:px-16")}>
            <div className={clsx("mx-auto max-w-4xl")}>
              <SingleImage image={image} caption={block.caption} />
            </div>
          </div>
        );
      }

      case "videoEmbed": {
        return (
          <div className={clsx("w-full px-6 lg:px-16")}>
            <div className={clsx("mx-auto max-w-4xl")}>
              <VideoEmbed videoUrl={block.videoUrl} caption={block.caption} />{" "}
            </div>
          </div>
        );
      }

      case "blockquote": {
        return (
          <div className={clsx("w-full px-6 lg:px-16")}>
            <div className={clsx("mx-auto max-w-prose")}>
              <Blockquote
                quote={block.quotation}
                attribution={block.attribution}
              />
            </div>
          </div>
        );
      }

      case "audioPlayer": {
        return <AudioPlayer file={block.audioFile[0]} />;
      }

      case "feedbackForm": {
        return (
          <div className={clsx("w-full px-6 lg:px-16")}>
            <div className={clsx("mx-auto max-w-prose")}>
              <FeedbackForm
                resource={resource}
                placeholderText={block.placeholderText}
                buttonLabel={block.buttonLabel}
              />
            </div>
          </div>
        );
      }

      default:
        return <div>Page component {block.typeHandle}</div>;
    }
  };

  return (
    <div className={clsx("ResourceBlocks", "space-y-10")}>
      {blocks.map((block) => {
        const className = clsx(
          style.block,
          style[`block___${block.typeHandle}`],
        );

        return (
          <div
            key={block.id}
            className={clsx(
              "ResourceBlocks__block",
              `ResourceBlocks__block--${block.typeHandle}`,
            )}
          >
            <Block spaceAbove={block.spaceAbove} spaceBelow={block.spaceBelow}>
              <Component block={block} />
            </Block>
          </div>
        );
      })}
    </div>
  );
};

export default ResourceBlocks;
